const DailyListingStatistic = ({
    displayedDate = '',
    totalInquiries = 0,
    totalListings = 0,
    totalPhoneLeads = 0,
    totalViewed = 0,
    totalBillableLeads = 0,
    totalBillableClicks = 0,
} = {}) => ({
    displayedDate: String(displayedDate),
    totalInquiries: Number(totalInquiries),
    totalListings: Number(totalListings),
    totalPhoneLeads: Number(totalPhoneLeads),
    totalViewed: Number(totalViewed),
    totalBillableLeads: Number(totalBillableLeads),
    totalBillableClicks: Number(totalBillableClicks),

});

export default DailyListingStatistic;
